import { ModeForm } from "constants/enum";
import { CREATE_SUCCESS_MESSAGE } from "constants/index";

import {
  QueryObserverResult,
  RefetchOptions,
  RefetchQueryFilters,
} from "@tanstack/react-query";
import { useCreateOneBaseRequestCandidateControllerRequestCandidateEntity } from "generated";
import { useNotification } from "hooks/useNotification";
import { useParams } from "react-router-dom";

import { RequestCandidateForm } from "./RequestCandidateForm";

interface PropTypes {
  setIsModalOpen: any;
  refetch: <TPageData>(
    options?: RefetchOptions & RefetchQueryFilters<TPageData>
  ) => Promise<QueryObserverResult<unknown, unknown>>;
  isModalOpen: boolean;
}
export const RequestCandidateCreateComponent = (props: PropTypes) => {
  const { setIsModalOpen, isModalOpen, refetch } = props;
  const { id } = useParams();
  const {
    mutate: addRequestCandidate,
    error: addRequestCandidateError,
    isSuccess: isSuccessRequestCandidate,
  } = useCreateOneBaseRequestCandidateControllerRequestCandidateEntity({
    mutation: {
      onSuccess() {
        refetch();
        setIsModalOpen(false); // eslint-disable-line
      },
    },
  });

  const handleSubmit = (dataRequestCandidate: any) => {
    addRequestCandidate({
      data: {
        candidateName: dataRequestCandidate?.candidateName,
        code: dataRequestCandidate?.code,
        status: dataRequestCandidate?.status,
        templateId: dataRequestCandidate?.templateId?.value,
        dueDate: dataRequestCandidate?.dueDate,
        dateOfBirth: dataRequestCandidate?.dob,
        email: dataRequestCandidate?.email,
        phoneNumber: dataRequestCandidate?.phoneNumber,
        position: dataRequestCandidate?.position,
        candidateInfo: dataRequestCandidate?.candidate,
        obDate: dataRequestCandidate?.obDate,
        fileUrl: JSON.stringify(dataRequestCandidate?.fileUrl),
        consentForm: JSON.stringify(dataRequestCandidate?.consentForm),
        degree: JSON.stringify(dataRequestCandidate?.degree),
        description: dataRequestCandidate?.description,
        requestId: id as string,
      },
    });
  };
  useNotification(
    (addRequestCandidateError?.response?.data as any) ?? addRequestCandidateError, // eslint-disable-line
    isSuccessRequestCandidate,
    CREATE_SUCCESS_MESSAGE
  );
  return (
    <RequestCandidateForm
      title="Checklist detail: Add new Candidate"
      subTitle="Add candidate into order list"
      handleSubmitForm={handleSubmit}
      setIsModalCreateOpen={setIsModalOpen}
      isModalOpen={isModalOpen}
      // isSpinning={false}
      mode={ModeForm.Create}
      isSuccess={isSuccessRequestCandidate}
    />
  );
};
